import { ICart, IDataLayer, IDataLayerEvent } from '../../../../types';
import toDataLayerLineItem from './line_item';
import { formatCurrencyToTwoDecimals } from '../../../utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function toDataLayer(cart: ICart): Record<string, any> {
  if (!cart) return {};

  type IAccumulator = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any[];
  };

  let lineItemData = {};
  const cartDataLayer = {
    cart_total_value: formatCurrencyToTwoDecimals(cart?.total_amount || 0),
    cart_total_items: cart?.total_quantity,
  };

  if (cart?.line_items?.length > 0) {
    lineItemData = cart.line_items.reduce<IAccumulator>((acc, lineItem) => {
      // check if lineItem is a sample
      if (lineItem.kind !== 'sample') {
        const itemData = toDataLayerLineItem(cart, lineItem, 'cart_product_');

        Object.keys(itemData).forEach((key) => {
          if (acc[key]) {
            acc[key] = acc[key].concat(itemData[key]);
          } else {
            acc[key] = itemData[key];
          }
        });
        return acc;
      }
      return acc;
    }, {});

    return {
      ...cartDataLayer,
      ...lineItemData,
    };
  } else {
    return {};
  }
}

export function detectCartPageEvents(
  prevData: IDataLayer,
  currentData: IDataLayer,
): IDataLayerEvent {
  const datalayer_events: IDataLayerEvent = prevData.datalayer_events || {};

  const currentCodes = currentData.cart_product_product_code || [];
  const prevCodes = prevData.cart_product_product_code || [];

  if (currentCodes.length !== prevCodes.length) {
    const removed = prevCodes.filter(
      (code: string) => !currentCodes.includes(code),
    );
    if (removed.length > 0) {
      datalayer_events['removeFromCart'] = {
        event_data: { product_code: removed },
      };
    }
  } else {
    const prevQty = prevData.cart_product_quantity || [];
    const currentQty = currentData.cart_product_quantity || [];

    const removed: string[] = [];
    const added: string[] = [];
    let updatedQty: number = 0;

    prevCodes.forEach((code: string, i: string | number) => {
      const pQty = prevQty[i];
      const cQty = currentQty[i];
      if (pQty > cQty) removed.push(code), (updatedQty = pQty - cQty);
      else if (pQty < cQty) added.push(code), (updatedQty = cQty - pQty);
    });

    if (removed.length > 0) {
      datalayer_events['removeFromCart'] = {
        event_data: {
          product_code: removed,
          product_quantity: [updatedQty],
        },
      };
    }

    if (added.length > 0) {
      datalayer_events['addToCart'] = {
        event_data: {
          product_product_code: added,
          is_bf_cart: true,
          product_quantity: [updatedQty],
        },
      };
    }
  }

  return datalayer_events;
}
